import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './style.css';

const App = () => {
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [showMessageArea, setShowMessageArea] = useState(false);
    const [loading, setLoading] = useState(false);
    const chatContainerRef = useRef(null);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [messages]);

    const handleSubmit = async () => {
        if (!input.trim()) return;
        
        setLoading(true);
        const newMessages = [...messages, { text: input, sender: 'user' }];
        setMessages(newMessages);
        setInput('');

        setTimeout(() => {
            setMessages([...newMessages, { text: "Hi, I'm missing my API key so this is all I can respond with currently. Sorry!", sender: 'ai' }]);
            setLoading(false);
        }, 2000);
    };

    const handleModelChange = (e) => {
        setSelectedModel(e.target.value);
        setShowMessageArea(true);
        setMessages([]);
        setInput('');
    };

    const handleBackToMenu = () => {
        setShowMessageArea(false);
        setMessages([]);
        setInput('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className="container">
            <div className={`app ${showMessageArea ? 'with-background' : ''}`}>
                <h1 className="animated-text">
                    {showMessageArea ? `Current LLM Model: ${selectedModel}` : "Chat with LLMs"}
                </h1>
                {!showMessageArea && (
                    <div className="select-llm-container">
                        <span className="select-llm-text">Select LLM:</span>
                        <select className="animated-text" value={selectedModel} onChange={handleModelChange}>
                            <option value="llama">Llama</option>
                            <option value="copilot">Copilot</option>
                            <option value="gemini">Gemini</option>
                            <option value="chatgpt">ChatGPT</option>
                            <option value="fluxpro">Flux Pro</option>
                            <option value="claude">Claude</option>
                            <option value="alpaca">Alpaca</option>
                            <option value="falcon">Falcon</option>
                            <option value="gemma">Gemma</option>
                        </select>
                    </div>
                )}
                {showMessageArea && (
                    <div className="message-area">
                        <textarea
                            id="textarea"
                            className="animated-text"
                            placeholder="Type your messages here..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <button className="send" onClick={handleSubmit}>Send</button>
                        <button className="change-llm" onClick={handleBackToMenu}>Change LLM</button>
                    </div>
                )}
                {loading && <div className="loading">Loading...</div>}
            </div>
            {showMessageArea && (
                <div className="chat-container" ref={chatContainerRef}>
                    {messages.map((msg, index) => (
                        <div key={index} className={`chat-bubble ${msg.sender}`}>
                            {msg.sender === 'user' ? 'You' : selectedModel}: {msg.text}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

ReactDOM.render(<App />, document.getElementById('root'));